const videoStyles = (theme) => ({
  videoPreview: {
    [theme.breakpoints.down('md')]: { marginBottom: theme.spacing(1) },
    [theme.breakpoints.down('sm')]: { marginBottom: 0 },
  },
});

export default videoStyles;
